import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    AfterViewInit,
    AfterViewChecked,
    ElementRef,
    ViewChild,
    SimpleChanges,
    HostListener,
    ViewEncapsulation
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PaginationComponent } from 'ngx-bootstrap/pagination';
import { CommonJS } from '../../functions/commonjs';
import {
    AngularTableColumn,
    AngularTableConfig,
    AngularTablePage,
    AngularTableResponsiveColumn
} from '../../models'

@Component({
    moduleId: module.id,
    selector: 'angular-table',
    templateUrl: 'angular-table.html',
    styleUrls: ['style-angular-table.css'],
    encapsulation: ViewEncapsulation.None
})
export class AngularTableComponent implements OnChanges, AfterViewInit, AfterViewChecked {

    public rows: Array<any> = [];
    public page: number = 1;
    public numPages: number = 1;
    public length: number = 0;
    tableRows: Array<any> = [];
    responsiveColumnsIntestazione: Array<AngularTableResponsiveColumn> = [];
    responsiveColumnsDettaglio: Array<AngularTableResponsiveColumn> = [];
    allRowsClosed: boolean = true;
    uniqueId: string = null;
    showResponsive: boolean = false;
    isDivContentFilled: boolean = true;
    isDivTableAutoheight: boolean = false;

    @ViewChild("divContent1") divContent1: ElementRef;
    @ViewChild("paginationComponent") paginationComponent: PaginationComponent

    @Output() onTableChanged = new EventEmitter();
    @Output() onCellClicked = new EventEmitter();
    @Output() onPageChanged = new EventEmitter();
    @Output() onSortChanged = new EventEmitter();
    @Output() onFilterChanged = new EventEmitter();
    @Output() onRowDataBound = new EventEmitter();

    @Input() data: Array<any>; // = TableData;
    @Input() checkableData: Array<boolean> = []; // = TableData non selezionabili;
    @Input() public noResultText: string = 'Nessun record disponibile';
    @Input() public globalSearchText: string = 'Cerca nei risultati...';
    @Input() public itemsPerPage: number = 10;
    @Input() public maxSize: number = 5;
    @Input() public columns: Array<AngularTableColumn> = [];
    @Input() public responsiveColumns: Array<AngularTableResponsiveColumn> = [];
    @Input() public showMainFilter: boolean = true;
    @Input() public showResultsNumber: boolean = true;
    @Input() public responsive: boolean = null;
    @Input() public responsiveWidth: number = null;
    @Input() public responsiveBootstrapWidth: number = null;
    @Input() public fixedTableHeight: number = null;
    @Input() public checkableRows: boolean = false;
    @Input() public autoHeightBottmMargin: number = -1;
    @Input() public config: AngularTableConfig = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: {
            filterString: '',
            columnName: ''
        },
        className: ['table-striped', 'table-bordered']
    };
    @Input() public forcedNoPagination: boolean = false;

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.setResponsive();
    }

    public constructor(private el: ElementRef, private sanitizer: DomSanitizer) {
        this.uniqueId = CommonJS.randomString(10);        
        document.addEventListener('blur', function (e: any) {
            e = e || window.event;
            var target = e.target || e.srcElement;
            //var text = target.textContent || text.innerText;   
            console.log(target);
        }, false);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes["data"]) {
            if (this.config.paging) this.page = 1;
            this.allRowsClosed = true;

            if (this.checkableRows && this.columns.find(a => a.name == "angular-table-row-checkbox") == null) {
                this.columns.unshift({
                    name: "angular-table-row-checkbox",
                    filtering: null,
                    sort: false,
                    title: ''
                });
            }
            if (this.checkableRows && this.data) {
                if (this.checkableData)
                {
                    for (let index = 0; index < this.data.length; index++) 
                    {
                        const element = this.data[index];                    
                        if(this.checkableData[index])
                        {
                            element['angular-table-row-checked'] = false;
                            element['angular-table-row-checkbox'] = "<input class='angular-table-check' type='checkbox'/>";
                        }
                        else 
                        {
                            element['angular-table-row-checked'] = false;
                            element['angular-table-row-checkbox'] = "";//"<input class='angular-table-check' type='checkbox' disabled='disabled'/>";
                        }
                        
                    }
                }
                else
                {
                    this.data.forEach(a => {
                        a['angular-table-row-checked'] = false;
                        a['angular-table-row-checkbox'] = "<input class='angular-table-check' type='checkbox'/>";
                    });
                }
               
            }
        }
        if (this.data) this.length = this.data.length;
        this.onChangeTable(this.config);
    }

    private setResponsive() {
        let reponsivePre = this.responsiveColumns && this.responsiveColumns.length > 0;
        if (this.responsive == null) {
            if (this.responsiveWidth) {
                this.showResponsive = CommonJS.getDisplayWidth() <= this.responsiveWidth && reponsivePre;
            }
            else if (this.responsiveBootstrapWidth) this.showResponsive = CommonJS.getBootstrapWidth() <= this.responsiveBootstrapWidth && reponsivePre;
            else this.showResponsive = CommonJS.getBootstrapWidth() <= CommonJS.BootstrapWidth.Medium && reponsivePre;
        }
        else this.showResponsive = this.responsive && reponsivePre;

        if (this.showResponsive) {
            this.responsiveColumnsIntestazione = this.responsiveColumns.filter(x => x.intestazione);
            this.responsiveColumnsDettaglio = this.responsiveColumns.filter(x => !x.intestazione);
        }

        if (this.autoHeightBottmMargin > -1) {
            setTimeout((controller = this) => {
                let divId: string = controller.uniqueId + '_table_div';
                let el: HTMLElement = document.getElementById(divId);
                var elemRect = el.getBoundingClientRect();
                let displayHeight = CommonJS.getDisplayHeight();
                if (elemRect.top < (displayHeight / 5 * 3)) {
                    controller.isDivTableAutoheight = true;
                    CommonJS.autoHeight(el, controller.autoHeightBottmMargin);
                } 
                else {
                    controller.isDivTableAutoheight = false;
                    CommonJS.autoHeightCancel(el);
                }
            }, 0);
        }
    }

    public changePage(page: AngularTablePage, data: Array<any> = this.data): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
        let result = data.slice(start, end);
        this.onPageChanged.emit(result);
        return result;
    }

    public changeSort(data: any, config: AngularTableConfig): any {
        if (!config.sorting) {
            this.onSortChanged.emit();
            return data;
        }

        let columns = this.config.sorting.columns || [];
        let columnName: string = void 0;
        let sort: string = void 0;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            this.onSortChanged.emit();
            return data;
        }

        // simple sorting
        this.onSortChanged.emit();
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }
            return 0;
        });
    }

    public changeFilter(data: any, config: AngularTableConfig): any {
        let filteredData: Array<any> = data;
        let htmlRegex: RegExp = /(<([^>]+)>)/ig;
        let filterRegex = new RegExp(this.config.filtering.filterString, 'gi');
        if (!this.columns || this.columns.length == 0) return;
        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name] && item[column.name].toString().replace(htmlRegex, "").match(filterRegex);
                });
            }
        });

        if (!config.filtering) {
            this.onFilterChanged.emit();
            return filteredData;
        }

        if (config.filtering.columnName) {
            this.onFilterChanged.emit();
            return filteredData.filter((item: any) =>
                item[config.filtering.columnName] && item[config.filtering.columnName].toString().replace(htmlRegex, "").match(filterRegex)
            )
        }

        let tempArray: Array<any> = [];
        if (filteredData && filteredData.length>0) {
            filteredData.forEach((item: any) => {
                let flag = false;
                this.columns.forEach((column: any) => {
                    if (item[column.name] && item[column.name].toString().replace(htmlRegex, "").match(filterRegex)) flag = true;
                });
                if (flag) tempArray.push(item);
            });
        }
        filteredData = tempArray;

        this.onFilterChanged.emit();
        return filteredData;
    }

    public onChangeTable(config: AngularTableConfig, page: AngularTablePage = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
        this.setResponsive();

        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        if (page && config.paging && this.paginationComponent) this.paginationComponent.page = page.page;
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
        this.onTableChanged.emit(this);
    }

    public onCellClick(data: any): any {
        if (data.column == 'angular-table-row-checkbox') 
        {
            if (data.row['angular-table-row-checkbox'])
                this.checkRow(data.row);
            else
                return;
        }
        
        this.onCellClicked.emit(data);
    }

    public checkRow(row: any) {
        if (this.checkableRows && row) {
            row['angular-table-row-checked'] = !row['angular-table-row-checked'];
            let checked: string = row['angular-table-row-checked'] ? 'checked' : '';
            row['angular-table-row-checkbox'] = "<input class='angular-table-check' type='checkbox' " + checked + "/>"
        }
    }

    ngAfterViewInit() {
        setTimeout(() => this.isDivContentFilled = this.divContent1.nativeElement.children.length > 0, 0);
    }

    ngAfterViewChecked() {
        let component = this;
        if (!this.showResponsive) {
            let tbody = this.el.nativeElement.querySelector('ng-table tbody');
            this.tableRows = tbody.getElementsByTagName('tr');
            if (this.tableRows && this.tableRows.length > 0) {
                for (let i: number = 0; i < this.tableRows.length; i++) {
                    let $event: any = {
                        tableRow: this.tableRows[i],
                        rowData: this.rows[i]
                    };
                    this.onRowDataBound.emit($event);
                    if (this.tableRows[i].cells) {
                        for (let j = 0; j < this.tableRows[i].cells.length; j++) {
                            let a = this.tableRows[i].cells[j];
                            a.onmousedown = function () {
                                let data = { row: component.rows[i], column: component.columns[j].name };
                                component.onCellClick(data);
                            }
                        }
                    }
                }
            }
        } else {
            let intestazioni = this.getIntestazioniResponsive();
            if (intestazioni && intestazioni.length > 0) {
                for (let i: number = 0; i < intestazioni.length; i++) {
                    let $event: any = {
                        tableRow: intestazioni[i],
                        rowData: this.rows[i]
                    };
                    this.onRowDataBound.emit($event);
                }
            }
        }
    }

    getAngularTableElement(): any {
        return this.el.nativeElement.querySelector('[id="' + this.uniqueId + '"]');
    }

    getIntestazioniResponsive(): any {
        return this.el.nativeElement.getElementsByClassName("intestazione");
    }

    getDettagliResponsive(): any {
        return this.el.nativeElement.getElementsByClassName("dettaglio");
    }

    getRowsResponsive(): any {
        return this.el.nativeElement.getElementsByClassName("angular-table-responsive");
    }

    getResponsiveCellValue(row, columnName) {
        let val: string = "" + row[columnName];
        if (!val || val.trim() == "") val = "&nbsp;";
        return this.sanitizer.bypassSecurityTrustHtml(val);
    }

    getResponsiveHeaderValue(row, columnName) {
        let val: string = "" + row[columnName];
        if (!val || val.trim() == "") val = "";
        return this.sanitizer.bypassSecurityTrustHtml(val);
    }

    responsiveCellClick(row, columnName) {
        let data = { row: row, column: columnName };
        this.onCellClicked.emit(data);
    }

    toggleResponsiveRow(rowIndex: number) {
        let dataRow = this.rows[rowIndex];
        if (dataRow) {
            if (dataRow["responsive_row_expanded"]) dataRow["responsive_row_expanded"] = false;
            else dataRow["responsive_row_expanded"] = true;

            if (dataRow["responsive_row_expanded"]) {
                let row = this.getIntestazioniResponsive()[rowIndex];
                if (row && CommonJS.getBootstrapWidth() < CommonJS.BootstrapWidth.Small) CommonJS.scrollToElement(row, "navbar-fixed-top");
                let a = 1;
            }
        }
        this.allRowsClosed = (this.rows.find(x => x["responsive_row_expanded"]) == undefined);
    }

    isRowExpanded(rowIndex: number) {
        if (!this.rows || this.rows.length == 0) return;
        let dataRow = this.rows[rowIndex];
        if (dataRow) {
            if (dataRow["responsive_row_expanded"]) return true;
            else {
                dataRow["responsive_row_expanded"] = false;
                return false;
            }
        }
    }

    toggleAllRows() {
        if (!this.rows || this.rows.length == 0) return;
        this.allRowsClosed = !this.allRowsClosed;
        this.rows.forEach(x => x["responsive_row_expanded"] = !this.allRowsClosed);
    }

    getCheckedRows(): Array<any> {
        let result: Array<any> = null;
        if (this.checkableRows && this.data) result = this.data.filter(a => a['angular-table-row-checked']);
        return result;
    }

    responsiveHeaderClass(column, row): any {
        let cssClass = {};
        let val: string = "" + row[column.name];
        if (!val || val.trim() == "") val = "";
        if (val != "") cssClass['intestazione-column'] = true;
        if (column.cssClass) cssClass[column.cssClass] = true;
        return cssClass;
    }

    pageChanged(config, $event) {
        if (this.isDivTableAutoheight) CommonJS.smoothScroll("#" + this.uniqueId + '_table_div_start');
        else CommonJS.smoothScroll("#" + this.uniqueId);
        this.onChangeTable(config, $event);
    }
}


// WEBPACK FOOTER //
// ./src/angular_library/components/table/angular-table.component.ts